var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4109 7.60763C12.457 7.60763 13.3128 6.75175 13.3128 5.70567C13.3128 4.65959 12.457 3.80371 11.4109 3.80371C10.3648 3.80371 9.50891 4.65959 9.50891 5.70567C9.50891 6.75175 10.3648 7.60763 11.4109 7.60763ZM11.4109 9.50959C10.3648 9.50959 9.50891 10.3655 9.50891 11.4116C9.50891 12.4576 10.3648 13.3135 11.4109 13.3135C12.457 13.3135 13.3128 12.4576 13.3128 11.4116C13.3128 10.3655 12.457 9.50959 11.4109 9.50959ZM11.4109 15.2155C10.3648 15.2155 9.50891 16.0714 9.50891 17.1174C9.50891 18.1635 10.3648 19.0194 11.4109 19.0194C12.457 19.0194 13.3128 18.1635 13.3128 17.1174C13.3128 16.0714 12.457 15.2155 11.4109 15.2155Z",
    fill: "#C5C7CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more - vertical.0ffd2090d5783e4dd780816ab52a3ec8.svg";
export { ForwardRef as ReactComponent };